//INJETA O TOGGLE DE TRADUÇÕES DENTRO DO HEADER EM 100 MS - PARTE DO CSS C/ OPACIDADE 0 (DENTRO DE THEMES.CSS)
window.addEventListener("load", function () {
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  if (isMobile) return;

  const interval = setInterval(() => {
    const switcher = document.querySelector('.tl-switcher');
    const target = document.querySelector('.header__action.flex.flex-end.align-center');

    if (switcher && target) {
      target.appendChild(switcher);
      switcher.classList.add('in-header');
      clearInterval(interval);
    }
  }, 10);
});
